import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import worldLanguages from "../../../../../auth/models/languages";
import { UtilsService } from "../../../../../auth/service/utils.service";
import { CitiesService } from "../../../../../auth/service/cities.service";
import { JobSiteService } from "../../../../../auth/service/job-sites.service";
import { UserFigureService } from "../../../../../auth/service/user-figure.service";
import { EducationTitleService } from "../../../../../auth/service/education-title.service";
import { SkillsService } from "../../../../../auth/service/skills.service";
import { CertificationService } from "../../../../../auth/service/certification.service";
import { ActivatedRoute, Router } from "@angular/router";
import { CustomerService } from "../../../../../modules/customer/customer.service";
import { AuthenticationService, UserService } from "../../../../../auth/service";
import { RequestService } from "../../request.service";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";

@Component({
  selector: "app-edit-request",
  templateUrl: "./edit-request.component.html",
  styleUrls: ["./edit-request.component.scss"],
})
export class EditRequestComponent implements OnInit {
  public contentHeader: IContentHeader;
  public formGroup: FormGroup;
  public showErrors: boolean = false;
  public items_skills: Array<any> = [];
  public languages_list: string[] = worldLanguages;
  public references_list: any[] = [];
  public filter_references_list: any[] = [];
  public current_request: any = {};
  public id_request: any;
  public commercialUsers: any = [];
  public toggleModalAdd: boolean = false;

  constructor(
    public _formBuilder: FormBuilder,
    public _utilService: UtilsService,
    public _citiesService: CitiesService,
    public _jobSiteService: JobSiteService,
    public _userFigureService: UserFigureService,
    public _educationTitleService: EducationTitleService,
    public _skillService: SkillsService,
    public _certificationService: CertificationService,
    public customerService: CustomerService,
    private _router: Router,
    private route: ActivatedRoute,
    public userService: UserService,
    public requestService: RequestService,
    public _authenticationService: AuthenticationService,
  ) {
    this._utilService.disableAutoHideLoading();
    this.id_request = this.route.snapshot.paramMap.get("id");
    this.formGroup = this._formBuilder.group({
      commercial: new FormControl("", [Validators.required, Validators.min(1)]),
      client: new FormControl("", [Validators.required, Validators.min(1)]),
      referent: new FormControl("", [Validators.required, Validators.min(1)]),
      city: new FormControl("", [Validators.required]),
      site: new FormControl("", [Validators.required]),
      figure: new FormControl([], [Validators.required]),
      description: new FormControl("", [Validators.required, Validators.minLength(2)]),
      education_title: new FormControl(""),
      certifications: new FormControl(""),
      languages: new FormControl(""),
      rate: new FormControl(""),
      priority: new FormControl(""),
    });
  }

  async ngOnInit() {
    if (!this._authenticationService.hasCapability("edit_customer_request")) {
      this._utilService.hideLoading();
      this._router.navigateByUrl("/dashboard/main");
      return false;
    }
    this._utilService.disableAutoHideLoading();
    await this._certificationService.getList();
    await this._skillService.getList();
    await this._userFigureService.getList();
    await this._educationTitleService.getList();
    await this.customerService.getCustomers();
    this.commercialUsers = await this.userService.getList("employee", "Commerciale,Direzione");
    this.references_list = await this.customerService.getReferents();
    this.current_request = await this.requestService.getRequest(this.id_request);
    this.formGroup.patchValue({
      commercial: this.current_request.commercial && this.current_request.commercial.hash ? this.current_request.commercial.hash : null,
      client: this.current_request.client_id,
      certifications: this.current_request?.certifications?.length > 0 ? this.current_request.certifications.map((item: any) => item.id) : null,
      languages: this.current_request?.languages?.length > 0 ? this.current_request.languages.map((item: any) => item) : null,
      city: this.current_request.city_id,
      site: this.current_request.site_id ? this.current_request.site_id : null,
      referent: this.current_request.referent.id,
      figure: [this.current_request.figure_id],
      description: this.current_request.description,
      education_title: this.current_request.education_title || null,
      rate: this.current_request && this.current_request.rate ? this._utilService.addDotsToNumber(this.current_request.rate) : this._utilService.addDotsToNumber(0),
      priority: this.current_request.priority,
    });
    if (this.current_request.figure_id_2) {
      this.formGroup.patchValue({
        figure: [this.current_request.figure_id, this.current_request.figure_id_2],
      });
    }
    if (this.current_request?.skills?.length > 0) {
      this.current_request.skills.map((item) =>
        this.items_skills.push({
          skill: item.skill,
          level: item.level,
          requested: item.requested === 1,
        }),
      );
    } else {
      this.addSkillItem();
    }

    this.changeReferentList();

    const headerTitle: string = await this._utilService.translate("MENU.EDIT_REQUEST").then((translation: string) => {
      return `${translation} ${this.current_request.request_name}`;
    });

    this.contentHeader = {
      headerTitle,
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: "MENU.RECRUITMENT",
            isLink: false,
          },
          {
            name: "MENU.CUSTOMERS_REQUESTS",
            isLink: true,
            link: "/dashboard/requests-list",
          },
          {
            name: headerTitle,
            isLink: false,
          },
        ],
      },
    };
    this._utilService.hideLoading();
  }

  changeReferentList() {
    this.filter_references_list = this.references_list.filter((item): any => {
      return item.client_id == this.formGroup.value.client;
    });
  }

  addSkillItem() {
    this.items_skills.push({ skill: 0, level: "junior", requested: 0 });
  }

  deleteSkillItem(index: number) {
    delete this.items_skills[index];
    this.items_skills = this.items_skills.filter((i) => i);
  }

  setMaxThreeSkillsAsRequested(skill: any, i: number) {
    let totalRequestedSkill = 0;
    this.items_skills.map((skillItem: any) => {
      if (skillItem.requested === true) {
        totalRequestedSkill++;
      }
    });
    if (totalRequestedSkill > 3) {
      if (skill.requested === true) {
        if (i === 0) {
          this.items_skills[i + 1].requested = false;
          return this._utilService.showSWALError({ text: "INSERT_MAX_THREE_REQUESTED_SKILL" });
        } else {
          this.items_skills[i - 1].requested = false;
          return this._utilService.showSWALError({ text: "INSERT_MAX_THREE_REQUESTED_SKILL" });
        }
      }
    }
  }

  formatRate() {
    this.formGroup.patchValue({
      rate: this._utilService.addDotsToNumber(this.formGroup.value.rate),
    });
  }

  fieldHasErrors(field_name: string): boolean {
    if (this.showErrors) {
      return this.formGroup.controls[field_name].status === "INVALID";
    } else {
      return this.formGroup.controls[field_name].status === "INVALID" && this.formGroup.controls[field_name].touched;
    }
  }

  async editRequest() {
    if (!this._authenticationService.hasCapability("edit_customer_request")) {
      await this._router.navigateByUrl("/dashboard/main");
      return false;
    }

    this.showErrors = true;
    // controllo valori
    if (this.formGroup.invalid) {
      window.scrollTo(0, 0);
      return false;
    }
    const keyToReplace: string[] = ["<br>", "</p>", "<p>", "<div>", "</div>", "<span>", "</span>", "&nbsp;"];
    let checkDescription = this.formGroup.value.description.trim();
    for (let key of keyToReplace) {
      checkDescription = checkDescription.replaceAll(key, "");
    }
    if (!!checkDescription) {
      checkDescription = checkDescription.trim();
    }
    if (!checkDescription) {
      this.formGroup.patchValue({
        description: null,
      });
      await this._utilService.showSWALError({ text: "INSERT_DESCRIPTION" });
      return false;
    }
    if (this.items_skills && this.items_skills.length < 1) {
      await this._utilService.showSWALError({ text: "ERROR_SKILLS_LIST_EMPTY" });
      return false;
    }
    //check duplicate skills
    const checkedArray = this.items_skills.reduce((unique, o) => {
      if (!unique.some((obj) => obj.skill === o.skill)) {
        unique.push(o);
      }

      return unique;
    }, []);
    if (this.items_skills.length !== checkedArray.length) {
      await this._utilService.showSWALError({ text: "ERROR_DUPLICATE_SKILL" });
      return false;
    }
    //END check duplicate skills

    let data = this.formGroup.value;
    const figures = this.formGroup.value.figure;
    data.figure = figures[0];
    data.figure2 = figures[1] ? figures[1] : null;
    data.skills = this.items_skills.filter((item: any) => item.skill != 0);
    data.priority = data.priority ? 1 : 0;

    if (data.skills.length == 0) {
      await this._utilService.showSWALError({ text: "SELECT_AT_LEAST_ONE_SKILL" });
      return false;
    }

    if (data.skills) {
      data.skills.map((item: any) => {
        item.requested = Number(item.requested);
      });
    }

    if (data.skills.filter((itemSkill: any) => Boolean(itemSkill.requested)).length == 0) {
      await this._utilService.showSWALError({ text: "SELECT_AT_LEAST_ONE_REQUESTED_SKILL" });
      return false;
    }

    if (!data.certifications) {
      data.certifications = [];
    }
    if (!data.languages) {
      data.languages = [];
    }
    this._utilService.showLoading();
    await this.requestService
      .editRequest(this.id_request, data)
      .then(async () => {
        this._utilService.hideLoading();
        await this._utilService.showSWALSuccess({ text: "SUCCESS_EDIT_CUSTOMER_REQUEST" });
        await this._router.navigateByUrl("/dashboard/detail-request/" + this.id_request);
      })
      .catch(async () => {
        this._utilService.hideLoading();
        await this._utilService.showSWALError({ text: "ERROR_EDIT_CUSTOMER_REQUEST" });
      });
  }

  showModalAdd() {
    this.toggleModalAdd = true;
  }

  async onReferentModalFormEvent(ref: any) {
    this.references_list = await this.customerService.getReferents();
    const newReferent: any = this.references_list.find((referent: any) => Number(referent.id) === Number(ref.id));
    setTimeout(() => {
      this.formGroup.patchValue({
        client: newReferent.client_id,
      });
      this.changeReferentList();
      this.formGroup.patchValue({
        referent: newReferent.id,
      });
    });
  }
}
